namespace TabAurous.Production {
    export interface SplittingForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        Parts: Serenity.IntegerEditor;
        NoOfSubBag: Serenity.IntegerEditor;
        EachSubBagPieces: Serenity.IntegerEditor;
        EachSubBagParts: Serenity.IntegerEditor;
        Details: SplittingItemsEditor;
        UserId: Serenity.IntegerEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class SplittingForm extends Serenity.PrefixedContext {
        static formKey = 'Production.Splitting';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SplittingForm.init)  {
                SplittingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = SplittingItemsEditor;

                Q.initFormType(SplittingForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherTypeId', w2,
                    'VoucherNo', w0,
                    'BagNo', w0,
                    'Pieces', w2,
                    'Weight', w3,
                    'Parts', w2,
                    'NoOfSubBag', w2,
                    'EachSubBagPieces', w2,
                    'EachSubBagParts', w2,
                    'Details', w4,
                    'UserId', w2,
                    'EmployeeId', w2,
                    'CompanyId', w2,
                    'FinancialYearId', w2
                ]);
            }
        }
    }
}
